/**
 * Geometry for the animated header mark.
 *
 * Generated from design/dynamic_logos/logo-variants.html, card 03
 * ("Bottom-Up Cascade · Ease"): the four bars morph from even, full-width
 * bars to staggered ones, the bottom bar leading and the top trailing.
 *
 * Do not hand-edit — the numbers are interpolated pairwise, so both states
 * must keep identical command structure.
 */

/** Resting state: four even, full-width bars. */
export const BAR_PATHS_REST: readonly string[] = [
  "M64.0355 0.50495C39.4201 0.492359 3.53533 -1.49565 1.03547 2.50495C-1.4644 6.50555 1.03552 32.505 3.53547 34.005C6.03541 35.505 40.4015 32.4901 64.0355 32.505C87.0838 32.5195 119.535 34.005 123.035 34.005C126.535 34.005 127.035 6.00525 126.035 2.50495C125.035 -0.995357 88.2606 0.517341 64.0355 0.50495Z",
  "M64.0355 44.5049C39.4201 44.4924 3.53533 42.5044 1.03547 46.5049C-1.4644 50.5055 1.03552 76.505 3.53547 78.005C6.03541 79.505 40.4015 76.4901 64.0355 76.505C87.0838 76.5195 119.535 78.005 123.035 78.005C126.535 78.005 127.035 50.0053 126.035 46.5049C125.035 43.0046 88.2606 44.5173 64.0355 44.5049Z",
  "M64.0355 88.5049C39.4201 88.4924 3.53533 86.5044 1.03547 90.5049C-1.4644 94.5055 1.03552 120.505 3.53547 122.005C6.03541 123.505 40.4015 120.49 64.0355 120.505C87.0838 120.519 119.535 122.005 123.035 122.005C126.535 122.005 127.035 94.0053 126.035 90.5049C125.035 87.0046 88.2606 88.5173 64.0355 88.5049Z",
  "M64.0355 132.505C39.4201 132.492 3.53533 130.504 1.03547 134.505C-1.4644 138.506 1.03552 164.505 3.53547 166.005C6.03541 167.505 40.4015 164.49 64.0355 164.505C87.0838 164.519 119.535 166.005 123.035 166.005C126.535 166.005 127.035 138.005 126.035 134.505C125.035 131.005 88.2606 132.517 64.0355 132.505Z",
];

/** Hover state: the same bars, staggered. */
export const BAR_PATHS_STAGGERED: readonly string[] = [
  "M32.9061 0.50495C20.2569 0.492359 1.81671 -1.49565 0.532097 2.50495C-0.752516 6.50555 0.532127 32.505 1.81678 34.005C3.10143 35.505 20.7612 32.4901 32.9061 32.505C44.75 32.5195 61.426 34.005 63.2246 34.005C65.0231 34.005 65.2801 6.00525 64.7662 2.50495C64.2523 -0.995357 45.3547 0.517341 32.9061 0.50495Z",
  "M49.4748 44.5049C34.685 44.4924 13.1242 42.5044 11.6221 46.5049C10.1201 50.5055 11.6222 76.505 13.1242 78.005C14.6263 79.505 35.2747 76.4901 49.4748 76.505C63.3231 76.5195 82.8212 78.005 84.9241 78.005C87.0271 78.005 87.3275 50.0053 86.7266 46.5049C86.1258 43.0046 64.0301 44.5173 49.4748 44.5049Z",
  "M44.0435 88.5049C27.1131 88.4924 2.4316 86.5044 0.712192 90.5049C-1.00721 94.5055 0.712231 120.505 2.43169 122.005C4.15115 123.505 27.7881 120.49 44.0435 120.505C59.8962 120.519 82.2164 122.005 84.6237 122.005C87.031 122.005 87.3749 94.0053 86.6871 90.5049C85.9993 87.0046 60.7055 88.5173 44.0435 88.5049Z",
  "M70.8964 132.505C52.1005 132.492 24.6995 130.504 22.7907 134.505C20.8818 138.506 22.7907 164.505 24.6996 166.005C26.6085 167.505 52.8499 164.49 70.8964 164.505C88.4957 164.519 113.275 166.005 115.948 166.005C118.62 166.005 119.002 138.005 118.239 134.505C117.475 131.005 89.3943 132.517 70.8964 132.505Z",
];

/**
 * Tightened to the artwork plus a one-unit margin.
 *
 * Both states together span x -1.46..127.03 and y -1.50..167.50, so the
 * reference box's 140.50 x 181.00 left roughly 9% of its width and 7% of its
 * height empty, and unevenly — which rendered the bars smaller than their box
 * and slightly off centre. At header size that read as four floating shapes
 * rather than as a mark.
 */
export const MARK_VIEW_BOX = "-2.5 -2.5 130.5 171";

/** Full sweep duration in milliseconds. */
export const SWEEP_DURATION_MS = 700;

/**
 * Fraction of the sweep at which each bar begins moving, top bar first in
 * array order. Bottom-up cascade: the last bar leads at 0, the first trails.
 * Reference easing: inOutCubic.
 */
export const BAR_START_OFFSETS: readonly number[] = [0.36, 0.24, 0.12, 0];
